import fontSizeControler from './fontSizeControler.vue';

export default fontSizeControler;
